import * as React from "react";

import Snackbar from "@material-ui/core/Snackbar";

import { observer, inject } from "mobx-react";

import { INotificationStoreProps } from "../../stores/INotificationStoreProps";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";

import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';


interface IToastProps {
}

const Alert = (props: AlertProps) =>{
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

@inject(PredefinedStoreName.NOTIFICATION)
@observer
class Toast extends React.Component<IToastProps & INotificationStoreProps> {


    public render() {
        
        const { notificationStore } = this.props;

        const onClose = () => {
            notificationStore!.closeToast();
        };
    
        return (
            <Snackbar
                anchorOrigin={{
                    horizontal: "center",
                    vertical: "bottom",
                }}
                onClick = {onClose}
                autoHideDuration={notificationStore!.timeout}
                onClose = {onClose}
                open={notificationStore!.visible}
            >
                <Alert onClose={onClose} severity={notificationStore?.type}  >
                    {notificationStore!.text}
                </Alert>
            </Snackbar>
        );
    }
};

export default Toast;
